import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { DropdownModule } from '../dropdown/dropdown.module';
import {
  GetTabHeadingDirective,
  GetTabOptionsDirective,
  SetTabHeadingDirective,
  SetTabOptionsDirective,
  TabComponent,
  TabContentComponent,
  TabHeadingComponent,
  TabOptionsComponent,
  TabSetComponent,
  TabWrapperComponent
} from './tab.component';
import { TabsDropdownTemplateComponent } from './tabsDropdown.template';

@NgModule({
  imports: [
    CommonModule,
    DropdownModule,
    FormsModule
  ],
  declarations: [
    GetTabHeadingDirective,
    SetTabHeadingDirective,
    GetTabOptionsDirective,
    SetTabOptionsDirective,
    TabWrapperComponent,
    TabSetComponent,
    TabComponent,
    TabHeadingComponent,
    TabContentComponent,
    TabOptionsComponent,
    TabsDropdownTemplateComponent
  ],
  exports: [
    GetTabOptionsDirective,
    GetTabHeadingDirective,
    SetTabHeadingDirective,
    SetTabOptionsDirective,
    TabWrapperComponent,
    TabSetComponent,
    TabComponent,
    TabHeadingComponent,
    TabContentComponent,
    TabOptionsComponent,
    TabsDropdownTemplateComponent
  ],
  entryComponents: [TabsDropdownTemplateComponent]
})
export class TabsModule {}
